import moment from "moment";
import ReactTableContainer from "../../components/ReactTable"
import { UserAvatarInfo } from "../../components/UserList";
import FarmerExportContainer from "../../container/FarmerExportContainer"
import { Input } from "../../components/Form";
import { Button } from "../../components/Button";
import { RiMore2Fill } from "react-icons/ri";
import { ModalBody, ModalHeader, ModalPanel } from "../../components/Modal";
import MessageContainer from "../../container/MessageContainer";
import MessageNewsContainer from "../../container/MessageNewsContainer";
import { SectorAutomationContainer } from "../../container/SectorAutomationContainer";
import { SendTermsOfUseContainer } from "../../container/SendTermsOfUseContainer";

const AnswerCell = ({ row }) => {
  const value = row?.original?.RESPOSTA || "Não respondido";

  return <div>
    {value === 'Ø' ? 'Não respondido' : `${value}`}
  </div>
}

const DateCell = ({ row }, isAssistance = true) => {
  const value = isAssistance ? row?.original?.DATA_DO_ATENDIMENTO : row?.original?.DATA_DA_RESPOSTA;
  return <div>
    {value ? moment(value).format('DD/MM/YYYY') : 'Sem data'}
  </div>
}

const columns = [
  {
    Header: "Todos",
    width: "70",
    disableSortBy: true,
    className: "todos",
  },
  {
    Header: "Produtor",
    accessor: "PRODUTOR",
    Cell: (info) => UserAvatarInfo(info, false),
    imgAccessor: "image",
    emailAccessor: "Email",
    width: "380",
    minWidth: "380",
    disableSortBy: true,
  },
  {
    Header: "Técnico",
    accessor: "TECNICO",
    width: "210",
    minWidth: "210",
    disableSortBy: true,
  },
  {
    Header: "Formulário",
    accessor: "FORMULÁRIO",
    width: "210",
    minWidth: "210",
    disableSortBy: true,
  },
  {
    Header: "Pergunta",
    accessor: "PERGUNTA",
    width: 200,
    minWidth: 200
  },
  {
    Header: "Resposta",
    accessor: "RESPOSTA",
    Cell: (value) => AnswerCell(value),
    width: 200,
    minWidth: 200
  },
  {
    Header: "Data do Atendimento",
    accessor: "DATA_DO_ATENDIMENTO",
    Cell: (value) => DateCell(value),
    width: "210",
    minWidth: "210",
    disableSortBy: true,
  },
  {
    Header: "Data da Resposta",
    accessor: "DATA_DA_RESPOSTA",
    Cell: (value) => DateCell(value, false),
    width: "210",
    minWidth: "210",
    disableSortBy: true,
  },
]

export const TermsOfUseListScreen = ({
  loading,
  data = [],
  handleFilter,
  handleOpenActionsModal,
  modalActions,
  handleCloseActionsModal,
  selectedUsers,
  handleSelectedUsers,
  selectedRows,
  isUserAdmin
}) => {
  return <div className="farmer-screen">
    <div className="filter-buttons">
      <div className="input-select">
        <>
          <Input
            placeholder="Pesquise pelo nome ou email"
            onChange={(e) => handleFilter(e.target.value)}
            hasIcon={<i class="fi fi-rr-search"></i>}
            isWhite
            hasFocus={false}
          />
        </>
      </div>
      <div className="buttons">
        <Button
          hiddenText
          hasIcon={<RiMore2Fill size={16} />}
          label='Ações'
          handleClick={handleOpenActionsModal}
          color="orange"
          className="dashboard"
          isDisabled={!selectedUsers || !selectedUsers.length}
          count={selectedUsers.length || ''}
        />
      </div>
    </div>
    <ReactTableContainer
      className="table-terms-of-use"
      selecteds={selectedRows}
      keyCompare='PRODUTOR_ID'
      onSelect={handleSelectedUsers}
      columns={columns}
      data={data}
      loadingTable={loading}
      canSelect
    />
    <ModalPanel modalIsOpen={modalActions}>
      <ModalHeader closeModal={handleCloseActionsModal} title="Ações" />
      <ModalBody>
        <div className="modal-buttons-group">
          <div className="modal-buttons">
            <MessageContainer selectedsUsers={selectedUsers} />
            <MessageNewsContainer selectedsUsers={selectedUsers} />
            {isUserAdmin && <FarmerExportContainer selectedsUsers={selectedUsers} />} {/* Apenas admin */}
            <SectorAutomationContainer
              selectedUsers={selectedUsers}
              closeModal={handleCloseActionsModal}
            />
            <SendTermsOfUseContainer selectedUsers={selectedUsers} />
          </div>
        </div>
      </ModalBody>
    </ModalPanel>
  </div>
}